import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleDropdown, closeDropdown, setCurrentSortOption } from './SortingDropdownReducer';
import SortingDropdown from './SortingDropdown';
import { ReactComponent as CheckIcon } from "./CheckIcon.svg";
import { useTouchClick } from "shared/hooks/useTouchClick";
import categorySound from "resources/music/물방울.mp3";
import style from './CategoryButtons.module.css';
import SortingArrowIcon from 'resources/img/icons/SortingArrowIcon';

const CategoryButton = ({ category, isSelected, onTouchClick }) => {
    const { handleTouchStart, handleTouchEnd } = useTouchClick(onTouchClick, 10);

    return (
        // <button
        //     className={style.btn}
        //     onPointerDown={handleTouchStart}
        //     onPointerUp={handleTouchEnd}
        //     style={{
        //         width: "242px",
        //         maxWidth: "242px",
        //         padding: '8px 18px',
        //         margin: "5px",
        //         backgroundColor: isSelected ? '#FF7919' : 'white',
        //         color: isSelected ? 'white' : 'black',
        //         border: "none",
        //         cursor: 'pointer',
        //         whiteSpace: 'nowrap',
        //         fontFamily: 'Pretendard, sans-serif',
        //         fontWeight: 600,
        //         fontSize: '1.25vw',
        //         flexShrink: 0,

        //     }}
        // >
        //     <CheckIcon
        //         style={{
        //             width: "24px",
        //             height: "18px",
        //             transform: "translate(-12px, 0)",
        //             stroke: isSelected ? 'white' : '#D7D7D7'
        //         }}
        //     />
        //     {category}
        // </button>

        <button
            className={style.btn}
            onPointerDown={handleTouchStart}
            onPointerUp={handleTouchEnd}
            style={{
                width: "18.95%",
                maxWidth: "18.95%",
                padding: '8px 18px',
                margin: "5px 10px 0px 0px",
                backgroundColor: isSelected ? '#FF7919' : 'white',
                color: isSelected ? 'white' : 'black',
                border: "none",
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontFamily: 'Pretendard, sans-serif',
                fontWeight: 600,
                fontSize: '1.25vw',
                flexShrink: 0,
                zIndex: 20

            }}
        >
            <CheckIcon
                style={{
                    width: "24px",
                    height: "18px",
                    transform: "translate(-12px, 0)",
                    stroke: isSelected ? 'white' : '#D7D7D7'
                }}
            />
            {category}
        </button>
    );
};

const SortButton = ({ category, isSelected, onTouchClick }) => {
    const { handleTouchStart, handleTouchEnd } = useTouchClick(onTouchClick, 10);

    return (
        <button
            className={style.btn}
            onPointerDown={handleTouchStart}
            onPointerUp={handleTouchEnd}
            style={{
                width: "18.95%",
                maxWidth: "18.95%",
                padding: '8px 18px',
                backgroundColor: 'white',
                color: '#FE531F',
                border: isSelected ? '1px solid #FE531F' : '1px solid #b1b1b1',
                borderRadius: '3px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontFamily: 'Pretendard, sans-serif',
                fontWeight: 600,
                fontSize: '1.25vw',
                flexShrink: 0,
                marginBottom: '0',
                marginLeft: 'auto',
                // 추가된 스타일
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px', // 텍스트와 아이콘 사이의 간격
                zIndex: 20

            }}
        >
            <span>{category}</span>
            <SortingArrowIcon width={32} height={32} />
        </button>
    );
};

const CategoryButtons2 = ({ categories, selectedProductCategory, onCategorySelect }) => {
    const dispatch = useDispatch();
    const { isOpen, currentSortOption, sortingOptions } = useSelector((state) => state.sortingDropdown);
    const audioRef = useRef();

    const handleCategoryClick = (category) => {
        if (category === currentSortOption) {
            dispatch(toggleDropdown());
            audioRef.current.play();
        } else {
            audioRef.current.play();
            onCategorySelect(category);
            if (isOpen) {
                dispatch(closeDropdown());
            }
        }
    };

    const handleSortOptionSelect = (option) => {
        audioRef.current.play();
        dispatch(setCurrentSortOption(option));
        onCategorySelect(option);
        dispatch(closeDropdown());
    };

    return (
        <div style={{ display: 'flex', gap: "7px", flexWrap: 'wrap', justifyContent: 'flex-start', position: 'relative' }}>
            <audio ref={audioRef} src={categorySound} preload="auto" />

            {/* 일반 카테고리 버튼들을 감싸는 div */}
            {/* <div style={{ display: 'flex', flexWrap: 'wrap', backgroundColor: "white", width: "max-content" }}> */}
            {categories.map((category) => (
                <CategoryButton
                    key={category}
                    category={category}
                    isSelected={selectedProductCategory === category}
                    onTouchClick={() => handleCategoryClick(category)}
                />
            ))}
            {/* </div> */}

            {/* 정렬 드롭다운 버튼 */}
            <SortButton
                category={currentSortOption}
                isSelected={selectedProductCategory === currentSortOption}
                onTouchClick={() => handleCategoryClick(currentSortOption)}
            />

            <SortingDropdown
                isOpen={isOpen}
                onSelect={handleSortOptionSelect}
                options={sortingOptions}
                currentSortOption={currentSortOption}
            />
        </div>
    );
};

export default CategoryButtons2;